/*
 * Copyright (C) Ivo Ladage-van Doorn - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Ivo Ladage-van Doorn <ivol37@gmail.com>, 2024
 */

import { FontAwesomeIcon, FontAwesomeLayers } from "@fortawesome/react-fontawesome";
import { faPlane } from "@fortawesome/free-solid-svg-icons";
import { InlineImage } from "../../components/InlineImage";
import AppBar from "@mui/material/AppBar";
import Day01 from "./Day01";
import Day02 from "./Day02";
import Day03 from "./Day03";
import Day04 from "./Day04";
import Day05 from "./Day05";
import Day06 from "./Day06";
import Day07 from "./Day07";
import Day08 from "./Day08";
import Day09 from "./Day09";
import Day10 from "./Day10";
import Day11 from "./Day11";
import Day12 from "./Day12";
import Day13 from "./Day13";
import Day14 from "./Day14";
import Day15 from "./Day15";
import Day16 from "./Day16";
import Day17 from "./Day17";
import Day18 from "./Day18";
import Day19 from "./Day19";
import Day20 from "./Day20";
import Day21 from "./Day21";
import Day22 from "./Day22";
import Day23 from "./Day23";
import { type CSSProperties, useEffect, useLayoutEffect, useRef, useState } from "react";

const toLeadImage = (image: string) => {
  return <InlineImage width="50%" image={"costarica/" + image + ".jpg"} />;
};

const pages = [Day01, Day02, Day03, Day04, Day05, Day06, Day07, Day08, Day09, Day10, Day11, Day12, Day13, Day14, Day15, Day16, Day17, Day18, Day19, Day20, Day21, Day22, Day23];

const dayButtonWidth = 36;
const dayButtonGap = 4;

function numberOfVisibleDays(width: number) {
  const daysThatFit = Math.floor((width + dayButtonGap) / (dayButtonWidth + dayButtonGap));
  const oddNumberOfDays = daysThatFit % 2 === 0 ? daysThatFit - 1 : daysThatFit;

  return Math.max(1, Math.min(pages.length, oddNumberOfDays));
}

function DagTotDagContent() {
  const [activeDay, setActiveDay] = useState(1);
  const [visibleDays, setVisibleDays] = useState(pages.length);
  const [dayMenuOffset, setDayMenuOffset] = useState(38);
  const menuRef = useRef<HTMLDivElement>(null);
  const ActivePage = pages[activeDay - 1];

  useEffect(() => {
    const menu = menuRef.current;
    if (!menu) return;

    const updateVisibleDays = () => setVisibleDays(numberOfVisibleDays(menu.clientWidth));
    updateVisibleDays();

    const observer = new ResizeObserver(updateVisibleDays);
    observer.observe(menu);
    return () => observer.disconnect();
  }, []);

  useLayoutEffect(() => {
    const dayMenu = menuRef.current;
    const tabList = dayMenu?.closest(".react-tabs")?.querySelector<HTMLElement>(".react-tabs__tab-list");
    if (!tabList) return;

    const updateDayMenuOffset = () => setDayMenuOffset(tabList.getBoundingClientRect().height);
    updateDayMenuOffset();

    const observer = new ResizeObserver(updateDayMenuOffset);
    observer.observe(tabList);
    return () => observer.disconnect();
  }, []);

  const daysOnEitherSide = Math.floor(visibleDays / 2);
  const firstVisibleDay = Math.min(Math.max(1, activeDay - daysOnEitherSide), pages.length - visibleDays + 1);
  const visibleDayNumbers = Array.from({ length: visibleDays }, (_, index) => firstVisibleDay + index);

  return (
    <>
      <div className="subMenu" ref={menuRef} style={{ "--submenu-height": `${dayMenuOffset}px` } as CSSProperties}>
        <div className="dayMenuDays" style={{ "--day-menu-slots": visibleDays } as CSSProperties}>
          {visibleDayNumbers.map((day) => (
            <button key={day} className={activeDay === day ? "active" : ""} onClick={() => setActiveDay(day)}>
              {day}
            </button>
          ))}
        </div>
        <div className="dayMenuSeparator" />
      </div>
      <ActivePage />
    </>
  );
}

export default function DagTotDag() {
  return <DagTotDagContent />;
}
